<template>
	<div class="cookies" v-if=" ! hidden">
		<div class="cookies-info" v-html="__('footer_cookie_text')"></div>

		<div class="cookies-btn" @click="accept()">
			OK
		</div>
	</div>
</template>

<script>
export default {
    name: 'Cookies',
    props: [],

    data() {
    	return {
			hidden: true
    	}
    },

    mounted() {
		if ( ! this.$getCookie('hasAcceptedCookies')) {
			this.hidden = false
		}
    },

    methods: {
		accept() {
			this.hidden = true
			
			this.$setCookie('hasAcceptedCookies', 1)
		}    	
    }
}
</script>